import _en from './translations/en.json.mjs';
import { useI18n } from '@shopify/react-i18n';
import { CommonActionTypeValue } from './types.mjs';

// TODO: Does not guarantee a return value for `content`, which could be a problem for some components.
// We may want to default to a `type`, or have a common fallback string.
function useCommonAction({
  type,
  content,
  accessibilityLabel,
  disabled,
  url,
  onAction
}) {
  const [i18n] = useI18n({
    id: 'useCommonAction_13i1kqx',
    fallback: _en,
    translations(locale) {
      if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
        return;
      }
      return import( /* webpackChunkName: "useCommonAction_13i1kqx-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
    }
  });
  const defaultContent = type ? i18n.translate(`CommonAction.${CommonActionTypeValue[type]}.content`) : undefined;
  const defaultLabel = type ? i18n.translate(`CommonAction.${CommonActionTypeValue[type]}.accessibilityLabel`) : undefined;
  const parsedContent = content || defaultContent;
  const parsedLabel = accessibilityLabel || defaultLabel;
  return {
    ...(parsedContent && {
      content: parsedContent
    }),
    ...(parsedLabel && {
      accessibilityLabel: parsedLabel
    }),
    ...(disabled && {
      disabled
    }),
    ...(url && {
      url
    }),
    ...(onAction && {
      onAction
    })
  };
}

export { useCommonAction };
